import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriOrderExpressComponent } from 'src/app/components/gonvarri-order-express/gonvarri-order-express.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    GonvarriOrderExpressComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriOrderExpressComponent: {
          component: GonvarriOrderExpressComponent
        }
      }
    })
  ],
})
export class GonvarriOrderExpressModule { }
